export default "__VITE_ASSET__Ch36O07u__"